<template>
  <b-modal :id="modalId" :title="modalTitle" @shown="$emit('show')" @hidden="closeModal">
    <div slot="modal-header">
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title">{{ modalTitle }}</h4>
    </div>
    <div class="form-group">
      <a :href="pdfBrowserUrl" class="pdf-link" target="_blank">
        <img src="../../../../../public/img/pdf_file.svg" class="icon-pdf" alt="icon-pdf" />
        {{ application.number }}.pdf
      </a>
    </div>
    <div class="form-group field-certListBox">
      <label class="control-label" :for="certListBoxId"
        >Выбрать сертификат</label
      >
      <select
        :id="certListBoxId"
        class="form-control"
        size="4"
        aria-invalid="false"
        @change="loadExternalInfo"
      ></select>
      <div class="help-block"></div>
      <div class="extended-info" v-html="this.externalCertificateInfo"></div>
      <span v-if="externalCertificateInfo.includes('Доверенность: не найдена')" @click="$bvModal.show('power-of-attorney-modal')" style="color: unset" class="btn btn-default text-primary font-weight-bold">Добавить доверенность</span>
      <power-of-attorney-modal
        @save="$bvModal.hide('power-of-attorney-modal')"
      />
    </div>
    <template v-slot:modal-footer>
      <div class="support">
        Поддержка сервиса: <br>
        <a href="https://konversta.com/ru/help/signature/" target="_blank" class="widget-button-left konversta-link">
          <img :src="baseUrl + '/vue/img/konversta.png'" alt style="width: 120px;">
        </a>
      </div>
      <div>
        <button type="button" class="btn btn-success widget-button-right" id="signButton"
                :disabled="disabledSignButton"
                @click="signAndApproveCommand();setPreload()"
        >
          <span class="button__text">Подписать и отправить</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import mainMixin from '../../../mixins/mainMixin'
import { ApiClient } from '../../../helpers/api-client/ApiClient'
import externalInfoMixin from '../../../mixins/externalInfoMixin'
import PowerOfAttorneyModal from '@/common/components/PowerOfAttorneyModal.vue'

export default {
  name: 'SignModal',
  components: { PowerOfAttorneyModal },
  mixins: [
    mainMixin,
    externalInfoMixin
  ],

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      disabledSignButton: true
    }
  },

  beforeDestroy () {
    this.closeModal()
  },

  props: {
    signAndApproveCommand: {
      type: Function
    },

    application: {
      type: Object,
      required: true
    },

    organization: {
      type: Object,
      required: false
    },

    certListBoxId: {
      type: String,
      required: true
    },

    modalId: {
      type: String,
      required: true
    },

    modalTitle: {
      type: String,
      default: 'Электронная подпись'
    },

    externalInfo: {
      type: String,
      default: ''
    },

    signer: {
      type: Object
    }
  },

  computed: {
    pdfBrowserUrl () {
      return ApiClient.getPdfBrowserUrl(this.application)
    },

    user () {
      return this.$store.getters.user
    },

    enableStrictCheckCertificate() {
      return true
    },

    enableStrictCheckCertificateSB() {
      return this.configuration.enable_strict_check_certificate_sb
    }
  },

  methods: {
    closeModal () {
      this.$bvModal.hide(this.modalId)
      const html = document.getElementsByTagName('html')[0]
      html.classList.remove('html-modal-open')
    },

    enableSignButton() {
      this.disabledSignButton = false;
    },

    disableSignButton() {
      this.disabledSignButton = true;
    },

    unsetPreload() {
      this.enableSignButton();
      const button = document.getElementById('signButton')
      button.classList.remove('button--loading')
    },

    setPreload() {
      this.disableSignButton();
      const button = document.getElementById('signButton')
      button.classList.toggle('button--loading')
    }
  }
}
</script>
